import type { RequestFn } from '../http';
import type {
  CreateTicketPayload,
  CreateTicketResponse,
  TicketAssistLookupItem,
  TicketAssistResponse,
  TicketCreation,
  TicketDefaults,
  TicketDispatchRankResponse,
  TicketDispatchRankWeclappResponse,
} from '../types';

export function createTicketsApi(request: RequestFn) {
  return {
    async createTicket(data: CreateTicketPayload) {
      return request<CreateTicketResponse>('/tickets', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async getMyTicketCreations(limit = 20, offset = 0) {
      return request<{ ticketCreations: TicketCreation[] }>(
        `/tickets/my-creations?limit=${limit}&offset=${offset}`
      );
    },

    async getTicketDefaults() {
      return request<{ defaults: TicketDefaults }>('/tickets/defaults');
    },

    async postTicketAssist(body: {
      summary?: string;
      description?: string;
      companyName?: string;
      priorities?: TicketAssistLookupItem[];
      types?: TicketAssistLookupItem[];
    }) {
      return request<TicketAssistResponse>('/tickets/assist', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async postTicketDispatchRank(body: {
      tickets: {
        id: number;
        summary: string;
        companyName?: string;
        slaSeverity?: string;
        attentionScore?: number;
      }[];
    }) {
      return request<TicketDispatchRankResponse>('/tickets/assist/dispatch-rank', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async postTicketDispatchRankWeclapp(body: {
      tickets: {
        id: string;
        summary: string;
        companyName?: string;
        slaSeverity?: string;
        attentionScore?: number;
      }[];
    }) {
      return request<TicketDispatchRankWeclappResponse>('/tickets/assist/dispatch-rank-weclapp', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },
  };
}
